import React, { useState } from "react";
import styles from "./Styles/TaskComp.module.css";
import { MdDeleteForever } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { discardRunningApi } from "../../Redux/Tasks/Task.actions";
import useElapsed from "./useElapsed";
import ConfirmModal from "../common/ConfirmModal";
import ProjectBadge from "../common/ProjectBadge";
import Tooltip from "../common/Tooltip";
import { formatHMS } from "../Reports/reportFormat";
import { useI18n } from "../../i18n/I18nContext";

// The row for the entry the timer is on. It's deliberately not a
// TaskComponent: there is nothing to edit yet (its end doesn't exist and its
// start belongs to the server), so it only shows what's being tracked, how
// long for, and offers to throw it away without recording anything.
const RunningTask = ({ item }) => {
  const { t } = useI18n();
  const [showDiscardConfirm, setShowDiscardConfirm] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const { currentOrgId } = useSelector((state) => state.organizations);
  const { projects } = useSelector((state) => state.projects);
  const { clients } = useSelector((state) => state.clients);
  const dispatch = useDispatch();
  const elapsed = useElapsed(item.startedAt);

  const project = projects.find((p) => p.id === item.projectId);

  const handleDiscard = () => {
    setShowDiscardConfirm(false);
    dispatch(discardRunningApi(currentOrgId, user.token));
  };

  return (
    <div className={styles.Task}>
      <div className={styles.Desc}>
        <div className={styles.Up}>
          <h6>{item.text}</h6>
        </div>
        <div className={styles.Projects}>
          <ProjectBadge project={project} clients={clients} />
        </div>
        <div className={styles.Time}>
          <span className={styles.RunningLabel}>{t("timeTracker.running")}</span>
          <span>{formatHMS(elapsed)}</span>
          {item.billable === false && <span>{t("timeTracker.nonBillable")}</span>}
        </div>
        <div className={styles.RowActions}>
          <Tooltip label={t("timeTracker.discardRunning")}>
            <button type="button" className={styles.Tags2} onClick={() => setShowDiscardConfirm(true)}>
              <MdDeleteForever style={{ fontSize: "20px" }} />
            </button>
          </Tooltip>
        </div>
      </div>

      <ConfirmModal
        show={showDiscardConfirm}
        title={t("timeTracker.discardRunningTitle")}
        body={t("timeTracker.discardRunningBody")}
        confirmLabel={t("common.delete")}
        onConfirm={handleDiscard}
        onCancel={() => setShowDiscardConfirm(false)}
      />
    </div>
  );
};

export default RunningTask;
